import { usePromisedRequest } from "../Common/request";
import { resolveNoContent, resolveWithBody } from "./Utils/utils";
import { EventDate } from "../Common/types";
import { Bundle } from "../Common/consts";

export type MainStats = {
    registeredCompetitors: number | null;
    confirmedPayments: number | null;
    totalVerifications: number | null;
    eventCost: string | null;
};

export type EventFederationSummary = {
    id: string;
    name: string;
    canAccessManagement: boolean;
};

export type BasicEventData = {
    fullName: string;
    eventDate: EventDate;
    timezone: string;
    federation: EventFederationSummary | null;
};

export type ActionableItem = {
    actionName: string;
    actionValue: string | null;
    position: number;
    status: "done" | "pending";
    actionUrl: string | null;
    helpCenterUrl: string | null;
    dismissible: boolean;
    actionGroup: string;
};

export type AdminEventSummary = {
    basicEventData: BasicEventData;
    mainStats: MainStats;
    actionableItems: ActionableItem[];
    bundles: Bundle[];
    hasBroadAccess: boolean;
};

export const adminEventSummaryApi = {
    getAdminEventSummary(eventId: number): Promise<AdminEventSummary> {
        return usePromisedRequest<AdminEventSummary>({
            url: `/api/admin/events/${eventId}/summary`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
    dismissActionableItem(eventId: number, actionName: string): Promise<void> {
        return usePromisedRequest<void>({
            url: `/api/admin/events/${eventId}/summary/actionable-items/${actionName}`,
            method: "delete",
            json: true,
        }).then(resolveNoContent());
    },
};
